import React from "react";
import { Route, Routes } from "react-router-dom";
import { ContextProvider } from "context";
import { ErrorPage, QrCodePage, QrCodeInactivePage } from "./pages";

export const App = (): JSX.Element => {
    return (
        <ContextProvider>
            <Routes>
                <Route path="/qrcode/:code" element={<QrCodePage />} />
                <Route path="/inactive" element={<QrCodeInactivePage />} />
                <Route path="/error" element={<ErrorPage />} />
                <Route path="/" element={<ErrorPage />} />
            </Routes>
        </ContextProvider>
    );
}
